import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/shared/ui/dialog";
import { Button } from "@/shared/ui/button";
import { useId } from "react";
import type { ClassificationRule } from "@/services/api/classification-rules";

interface ClassificationRuleDeleteDialogProps {
  open: boolean;
  rule: ClassificationRule | null;
  isLoading?: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export function ClassificationRuleDeleteDialog({
  open,
  rule,
  isLoading,
  onOpenChange,
  onConfirm,
}: ClassificationRuleDeleteDialogProps) {
  const descriptionId = useId();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent aria-describedby={descriptionId}>
        <DialogHeader>
          <DialogTitle>Delete classification rule</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete the classification rule for{" "}
            <span className="font-medium text-ink-900">
              {rule?.category ?? "this rule"}
            </span>
            ? This action cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="mt-4">
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
          <Button
            type="button"
            variant="default"
            onClick={onConfirm}
            disabled={isLoading}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
